import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import pink from "images/pink.jpg";
import ModalContext from "../components/contexts/ModalContext";
import Popup from "popup/Popup";
import log from "loglevel";
import { toast } from "sonner";
import { AUTH_STATUS } from "constants/auth";
import client from "api/WookAxios";
import consentList from "auth/register/consentList";

const StyledBox = styled.div`
  background-color: #fbfbfd;
  height: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledFrame = styled.div`
  margin-top: 40px;
  width: 1024px;
  // height: 650px;
  aspect-ratio: 1100 / 650;
  // background: blue;

  @media (max-width: 768px) {
    margin-top: 0;
    width: 100%;
    aspect-ratio: 1100 / 650;
  }

  @media (max-width: 1024px) {
    margin-top: 0;
    width: 100%;
    aspect-ratio: 1100 / 650;
  }
`;

const StyledImg = styled.div`
  width: 100%;
  aspect-ratio: 1100 / 650;

  // transition: 1s ease-in;
  // &:hover {
  //   transform: scale(1.1);
  //   overflow: hidden;
  // }

  @media (max-width: 768px) {
    // transform: scale(1.5);
    // overflow: hidden;
  }
`;

const StyledProverb = styled.div`
  color: #000000;
  font-family: "Roboto-Bold", Helvetica;
  font-size: 18px;
  font-weight: 700;
  float: right;
  margin-right: 10px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const MobileDescription = styled.div`
  display: none;
  // background: red;

  @media (max-width: 1024px) {
    // display: block;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const StyledTitle = styled.div`
  color: #2a64c5;
`;

const StyledDetail = styled.div`
  color: #000000;
`;

export const MainPage = () => {
  const { modalActions } = useContext(ModalContext);
  const location = useLocation();
  const navigate = useNavigate();

  
  const onTest = async () => {
    console.log('test');
    try {
      const response = await client.get('/api/v1/oauth/google/user-info/');

      console.log(response);
      console.log(response.data);
    } catch(e) {
      console.log(e);
      console.log(e.response.data.errors);
    }
  };

  const getProvider = () => {
    return document.querySelector('input[name="provider"]:checked')?.value;
  };

  const onRefresh = async () => {
    console.log('refresh');
    const provider = getProvider();
    
    try {
      const response = await client.post(`/api/v1/oauth/${provider}/refresh/`);
      console.log(response);
      console.log(response.data);
    } catch(e) {
      console.log(e);
      console.log(e.response.data.errors);
    }
  };

  const onRevoke = async () => {
    console.log('revoke');
    const provider = getProvider();

    try {
      const response = await client.post(`/api/v1/oauth/${provider}/revoke/`);      
      console.log(response);
      console.log(response.data);
    } catch(e) {
      console.log(e);
      console.log(e.response.data.errors);
    }
  };
  
  return (
    <div className="MainPage">
      <StyledBox>
        <StyledFrame>
          <StyledImg>
            <img src={pink} width="100%" height="100%" alt="pink-image" />
          </StyledImg>
          <StyledProverb>
            A smile is a curve that sets everything straight. ― Phyllis Diller.
          </StyledProverb>
        </StyledFrame>
        <MobileDescription>
          <StyledTitle>
            서울대학교 치과대학 2005 동기 홈페이지 입니다.
          </StyledTitle>
          <StyledDetail>해당되는 분만 회원가입 후 이용해주세요.</StyledDetail>
        </MobileDescription>

        {process.env.NODE_ENV === 'development' && (
          <div>
            <button onClick={onTest}>Test</button><br /><br />
            <form>
              <input type="radio" name="provider" value="naver" defaultChecked />naver
              <input type="radio" name="provider" value="kakao" />kakao
              <input type="radio" name="provider" value="google" />google
            </form>
            <br />
            <button onClick={onRefresh}>refresh</button>
            <button onClick={onRevoke}>revoke</button>
          </div>
        )}
      
      </StyledBox>
      {/* <Popup /> */}
    </div>
  );
};